import React from 'react';
import { FiUser, FiBell, FiSettings, FiLogOut, FiChevronDown } from 'react-icons/fi';
import { apiClient, tokenManager } from '../utils/api';
import { Link } from 'react-router-dom';

const PageHeader = ({ 
  title, 
  subtitle, 
  breadcrumbs = [], 
  actions = [],
}) => {
  const [showUserMenu, setShowUserMenu] = React.useState(false);
  const [notifications, setNotifications] = React.useState(3); // Example notification count
  const user = JSON.parse(localStorage.getItem('userData'));
  // console.log(user);
  const handleLogout = () => {
    apiClient.logout();
  };

  const isAuthenticated = tokenManager.isAuthenticated();

  return (
    <div className="bg-white shadow-sm border-b border-gray-200 px-6 py-4 mb-6">
      <div className="flex items-center justify-between">
        {/* Left side - Title and breadcrumbs */}
        <div className="flex-1">
          {/* Breadcrumbs */}
          {breadcrumbs.length > 0 && (
            <nav className="flex mb-2" aria-label="Breadcrumb">
              <ol className="flex items-center space-x-2">
                {breadcrumbs.map((crumb, index) => (
                  <li key={index} className="flex items-center">
                    {index > 0 && (
                      <span className="text-gray-400 mx-2">/</span>
                    )}
                    {crumb.href ? (
                      <a
                        href={crumb.href}
                        className="text-sm text-gray-500 hover:text-gray-700"
                      >
                        {crumb.label}
                      </a>
                    ) : (
                      <span className="text-sm text-gray-900">{crumb.label}</span>
                    )}
                  </li>
                ))}
              </ol>
            </nav>
          )}

          {/* Title and subtitle */}
          <div>
            <h1 className="text-2xl font-semibold text-gray-900">{title}</h1>
            {subtitle && (
              <p className="text-sm text-gray-600 mt-1">{subtitle}</p>
            )}
          </div>
        </div>

        {/* Center - Actions */}
        {actions.length > 0 && (
          <div className="flex items-center space-x-3 mx-6">
            {actions.map((action, index) => (
              <button
                key={index}
                onClick={action.onClick}
                className={`
                  flex items-center space-x-2 px-4 py-2 rounded-lg font-medium transition-colors
                  ${action.variant === 'primary' 
                    ? 'bg-primary-600 text-white hover:bg-primary-700' 
                    : 'bg-gray-100 text-gray-700 hover:bg-gray-200'
                  }
                `}
              >
                {action.icon && <span className="text-sm">{action.icon}</span>}
                <span className="text-sm">{action.label}</span>
              </button>
            ))}
          </div>
        )}

        {/* Right side - Notifications and User menu */}
        {isAuthenticated && (
          <div className="flex items-center space-x-4">
            {/* Notifications */}
            {/* <div className="relative">
              <button className="p-2 text-gray-400 hover:text-gray-600 relative">
                <FiBell className="h-5 w-5" />
                {notifications > 0 && (
                  <span className="absolute -top-1 -right-1 h-4 w-4 bg-red-500 text-white text-xs rounded-full flex items-center justify-center">
                    {notifications > 9 ? '9+' : notifications}
                  </span>
                )}
              </button>
            </div> */}

            {/* User menu */}
            <div className="relative">
              <button
                onClick={() => setShowUserMenu(!showUserMenu)}
                className="flex items-center space-x-3 p-2 rounded-lg hover:bg-gray-50 transition-colors"
              >
                <div className="h-8 w-8 rounded-full flex items-center justify-center">
                  {/* <FiUser className="h-4 w-4 text-white" /> */}
                  {user?.image ? (
                  <img src={user?.image} alt="User" className="h-8 w-8 rounded-full object-cover" />
                  ) : (
                    <FiUser className="h-4 w-4 text-white" />
                  )}
                </div>
                <div className="text-left hidden md:block">
                  <p className="text-sm font-medium text-gray-900">
                    {user?.name || 'John Doe'}
                  </p>
                </div>
                <FiChevronDown className="h-4 w-4 text-gray-400" />
              </button>

              {/* User dropdown menu */}
              {showUserMenu && (
                <div className="absolute right-0 mt-2 w-48 bg-white rounded-lg shadow-lg border border-gray-200 py-2 z-50">
                  {/* <button className="w-full text-left px-4 py-2 text-sm text-gray-700 hover:bg-gray-50 flex items-center">
                    <FiUser className="mr-3 h-4 w-4" />
                    Profile
                  </button>
                  <Link to="/dashboard/settings" className="w-full text-left px-4 py-2 text-sm text-gray-700 hover:bg-gray-50 flex items-center">
                    <FiSettings className="mr-3 h-4 w-4" />
                    Settings
                  </Link> */}
                  {/* <hr className="my-2" /> */}
                  <button
                    onClick={handleLogout}
                    className="w-full text-left px-4 py-2 text-sm text-red-600 hover:bg-red-50 flex items-center"
                  >
                    <FiLogOut className="mr-3 h-4 w-4" />
                    Sign out
                  </button>
                </div>
              )}
            </div>
          </div>
        )}

        {/* Add a button to go back to the previous page */}
      </div>

      {/* Click outside to close user menu */}
      {showUserMenu && (
        <div
          className="fixed inset-0 z-40"
          onClick={() => setShowUserMenu(false)}
        />
      )}
    </div>
  );
};

export default PageHeader; 